import { HomePage } from './pages/HomePage'

export const App = () => <HomePage />
